import { fetchCampaigns } from 'api/campaigns';
import { fetchContacts } from 'api/contacts/contacts';
import { fetchPledges } from 'api/pledges';
import { fetchTickets } from 'api/tickets';
import { fetchPlans } from 'api/transactionPlans';
import { fetchTransactions } from 'api/transactions';
import { ReportResource } from 'types/domain';

const fetchStrategy = (resource: ReportResource) => {
    switch (resource) {
        case 'contacts':
        case 'companies':
            return fetchContacts;
        case 'transactions':
            return fetchTransactions;
        case 'tickets':
            return fetchTickets;
        case 'campaigns':
            return fetchCampaigns;
        case 'transaction_plans':
            return fetchPlans;
        case 'pledges':
            return fetchPledges;
    }
};

export { fetchStrategy };
